import getScreenStream from './src/ArShareScreen';
export default getScreenStream;
